<template>
  <div id="app">
    <div v-if="isPc">
      <menus-nav></menus-nav>
      <router-view v-if="isRouterAlive" />
      <!-- <bottom-foot v-if="!isPCextension"></bottom-foot> -->
      <bottom-foot></bottom-foot>
      <side-bar></side-bar>
      <!-- <pc-suspension-dialog></pc-suspension-dialog> -->
    </div>

    <div v-if="!isPc">
      <router-view v-if="isRouterAlive" />
      <!-- <m-menus-bottom
        v-if="!isofficialAccount && !ismExtensionPage"
      ></m-menus-bottom> -->
      <m-menus-bottom
        v-if="!isofficialAccount"
      ></m-menus-bottom>
      <m-sidebar v-if="!isofficialAccount"></m-sidebar>
      <m-suspension-foot></m-suspension-foot>
    </div>
  </div>
</template>

<script>
import { deviceIsPc, checkNull } from "./filters/filters";
import menusNav from "./components/menusNav";
import foot from "./components/foot";
import sideBar from "./components/sideBar";
import mMenusBottom from "./components/mMenusBottom";
import mSidebar from "./components/mSidebar";
// import pcSuspensionDialog from "./components/pcSuspensionDialog";
import mSuspensionFoot from "./components/mSuspensionFoot";

export default {
  name: "App",

  components: {
    "menus-nav": menusNav,
    "bottom-foot": foot,
    "side-bar": sideBar,
    "m-menus-bottom": mMenusBottom,
    "m-sidebar": mSidebar,
    // "pc-suspension-dialog": pcSuspensionDialog,
    "m-suspension-foot": mSuspensionFoot,
  },

  provide() {
    // 注册一个方法
    return {
      reload: this.reload,
    };
  },

  computed: {},
  provide() {
    // 注册一个方法
    return {
      reload: this.reload,
    };
  },

  data() {
    return {
      isPc: true,
      isRouterAlive: true,
      isofficialAccount: false, //公众号的不要底部导航和侧边栏
      // ismExtensionPage: false, //移动端定制推广页要侧边栏不要底部
      // isPCextension: false, //PC端定制推广页要侧边栏不要底部
    };
  },

  created() {},

  mounted() {
    let body = document.getElementsByTagName("body")[0];
    let pathTemp = window.location.hash;
    let path = pathTemp.substring(1, pathTemp.length);

    // 公众号进入直接预约咨询
    if (path === "/mIndexPage") {
      this.isofficialAccount = true;
    }
    // if (path === "/mExtensionPage") {
    //   this.ismExtensionPage = true;
    // }
    // if (path === "/extensionPage") {
    //   this.isPCextension = true;
    // }

    // 看path里面是否包含数组下面的每一项字符串，如果在pc端，包含了移动端的路由，则跳转到pc端的首页，
    // 如果移动端的环境下，包含了pc端的路由项，则跳转到移动端的路由下

    let mRouterArr = [
      "/mNewsAndInfo",
      "/mIndex",
      "/mNewsAndInfoDetail",
      "/mAboutUser",
      "/mContactUs",
      "/mKnowUs",
      "/mJoinUs",
      "/mProdServH5",
      "/mProdServPc",
      "/mSolutionNormal",
      "/mSolutionTimelyDist",
      "/mSolutionProperty",
      "/mExtensionPage",
      "/mIndexPage",
    ];
    let pcRouterArr = [
      "/prodServH5",
      "/prodServPc",
      "/solutionNormal",
      "/solutionProperty",
      "/solutionTimelyDist",
      "/aboutUser",
      "/newsAndInfo",
      "/newsAndInfoDetail",
      "/index",
      '/extensionPage',
      "/jobRecruit", // ljl 1125
      "/jobPost", // ljl 1125
      "/jobRecruitDetail", // ljl 1125
    ];

    if (deviceIsPc()) {
      // PC somethings
      this.isPc = true;
      body.style.minWidth = "1300px";
      body.style.overflowX = "scroll";

      for (let item of pcRouterArr) {
        if (path.lastIndexOf(item) > -1) {
          this.$router.push({ path: path });
          break;
        } else {
          if (checkNull(this.$route.query.bd_vid)) {
            this.$router.push({ path: "/index" });
          } else {
            this.$router.push({
              path: "/index",
              query: { bd_vid: this.$route.query.bd_vid },
            });
          }
        }
      }
    } else {
      // Mobile somethings
      this.isPc = false;
      body.style.overflowX = "hidden";
      for (let item of mRouterArr) {
        if (path.lastIndexOf(item) > -1) {
          this.$router.push({ path: path });
          break;
        } else {
          if (checkNull(this.$route.query.bd_vid)) {
            this.$router.push({ path: "/mIndex" });
          } else {
            this.$router.push({
              path: "/mIndex",
              query: { bd_vid: this.$route.query.bd_vid },
            });
          }
        }
      }
    }
  },

  methods: {
    //页面注入刷新
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style lang="scss">
@import "styles/common";
@import "styles/variable";

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue